import React from 'react';
import { team } from '../data/site';
export function Team() {
  return <section id="team" className="bg-paper py-24" data-id="element-274" data-mp="uoxyivgoh5yu">
      <div className="mx-auto max-w-[1240px] px-6" data-id="element-275" data-mp="uppvoapxbbr8">
        <div className="grid gap-8 lg:grid-cols-[1.1fr_0.9fr] lg:items-end" data-id="element-276" data-mp="yqrwgvzhnvvb">
          <div data-id="element-277" data-mp="yof8a1350p9t">
            <p className="eyebrow text-green-dark" data-id="element-278" data-mp="13h89wg3b7hho">Our Team</p>
            <h2 className="mt-5 font-display text-[34px] font-medium leading-[1.15] tracking-[-0.01em] text-ink sm:text-[42px]" data-id="element-279" data-mp="13ijdaesuen89">
              Practitioners, not intermediaries.
            </h2>
          </div>
          <p className="text-[15px] leading-relaxed text-ink-70" data-id="element-280" data-mp="1dhip268wmyzh">
            Engagements are led by the practice head responsible for the discipline
            — the person signing the report is the person you meet.
          </p>
        </div>
        <div className="double-rule mt-9 w-full text-ink/40" aria-hidden="true" data-id="element-281" data-mp="3k6dtxw6wwbre" />

        <ul className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-282" data-mp="3o77dyeh8h6f0">
          {team.map(member => <li key={member.name} data-id="element-283" data-mp="1mj8szyykljvl">
              <div className="aspect-[4/5] w-full overflow-hidden border border-line" data-id="element-284" data-mp="1mjih1h021gyn">
                <img src={member.photo} alt="" aria-hidden="true" className="h-full w-full object-cover saturate-[0.65] transition duration-500 hover:saturate-100" data-id="element-285" data-mp="1hqz3gk1daltu" />
              </div>
              <h3 className="mt-4 font-display text-[19px] text-ink" data-id="element-286" data-mp="25i4mf82ltu8d">{member.name}</h3>
              <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.1em] text-ink-50" data-id="element-287" data-mp="20irnhoygkwpf">
                {member.role}
              </p>
            </li>)}
        </ul>

        <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.1em] text-ink-50" data-id="element-288" data-mp="1vl8b6ulbmu04">
          Names and portraits to be supplied by the firm — placeholder imagery shown.
        </p>
      </div>
    </section>;
}